module.exports = __webpack_public_path__ + "img/38.7de773b7.jpg";